// extracted by mini-css-extract-plugin
export default {"root":"Group_root__DuarP","close":"Group_close__b8VC0"};